import { ca } from '@cian/analytics';

interface ITrackNewbuildingFavoriteParams {
  products: unknown;
  page: Record<string, unknown>;
}

export function trackAddNewbuildingFavorite({ products, page }: ITrackNewbuildingFavoriteParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_listing_in_map_JK',
    products,
    page,
  });
}

export function trackDeleteNewbuildingFavorite({ products, page }: ITrackNewbuildingFavoriteParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_listing_in_map_JK',
    products,
    page,
  });
}
